// Shared tag types for RTK Query cache invalidation
export const tagTypes = [
    'Projects',
    'DocumentPackages',
    'Blob',
    'Blobs',
    'Findings',
    'FindingComments',
    'FindingCommenters',
    'LayoutOptimization',
    'LayoutOptimizationResults',
    'LayoutOptimizationFiles',
    'ProcessorJobs',
    'Files',
    'Users',
    'ProjectPermissions',
    'Organization',
    'Exports',
    'Invites',
    'NSCount',
    'UniqueDocumentTypes',
    'BlobNameList',
    'DashboardData',
    'StructuralEngineering',
    'StructuralEngineeringResults',
    'StructuralEngineeringFiles',
    'BuildingPackageFiles',
    'BuildingPackages',
    'BuildingPackageResults',
    'Meetings',
    'MeetingParticipants',
    'MeetingTranscripts',
    'MeetingSummary',
    'MeetingActionItems',
    'MeetingAgreements',
    'MeetingContradictions',
    'DocumentContradictions',
    'ReportTemplate',
    'DocumentPackageResults',
    'DocumentPackageSummary',
    'PipelineDashboard',
    'Feedback',
    'VersionComparisons',
];
